import { createFileRoute, Outlet } from '@tanstack/react-router'
import { NavTabs } from '@/ui/kit/NavTabs'
import { Page } from '@/ui/kit/Page'

/**
 * Config.
 *
 * Virou camada quando o plano B ganhou tela própria: a chave continua na
 * `/app/config`, e cada assunto novo entra como filho em vez de crescer numa
 * página só. A aba diz o assunto, então os cartões não repetem o nome dela.
 */

const ABAS = [
  { label: 'Chave e recuperação', to: '/app/config' },
  { label: 'Consultório', to: '/app/config/consultorio' },
  { label: 'Recibos', to: '/app/config/recibos' },
  { label: 'Textos', to: '/app/config/textos' },
  { label: 'Termos', to: '/app/config/termos' },
  { label: 'Plano B', to: '/app/config/plano-b' },
] as const

export const Route = createFileRoute('/_app/app/config')({
  staticData: { crumb: { label: 'Config' } },
  component: function ConfigLayout() {
    return (
      <Page title="Configurações" tabs={<NavTabs tabs={ABAS} label="Assuntos da configuração" />}>
        <Outlet />
      </Page>
    )
  },
})
